
import Checklist from 'vux/src/components/checklist/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
components: {Checklist, XButton},
data() {
return {
redPackAmount: '',
needAmount: '',

redPackageDisplay: 'none', //领取红包成功的弹窗显示
hdClassBtn: 'new-year-but1', //开字本生的class
trans: false, //开字是否旋转

hasAccess: false, //是否有参加活动的权利
noSubmit: false, //是否允许提交
answer: [], // 选择的答案，二维数组
textBtn: '提交',
success: false, //调查提交成功
questions: [
{
id: 1,
title: '您的年龄？',
answerChooseList: [
{key: '1', value: '25岁以下'},
{key: '2', value: '25 - 49岁'},
{key: '3', value: '50 - 59岁'},
{key: '4', value: '60岁以上'},
]
},
{
id: 2,
title: '您的性别？',
answerChooseList: [
{key: '1', value: '男'},
{key: '2', value: '女'},
]
},
{
id: 3,
title: '您是否有眼干涩？',
answerChooseList: [
{key: '1', value: '有'},
{key: '2', value: '无'},
]
},
{
id: 4,
title: '您是眼部否有红血丝？',
answerChooseList: [
{key: '1', value: '有'},
{key: '2', value: '无'},
]
},
{
id: 5,
title: '您是否有眼痒？',
answerChooseList: [
{key: '1', value: '有'},
{key: '2', value: '无'},
]
},
{
id: 6,
title: '您是否有视疲劳？',
answerChooseList: [
{key: '1', value: '有'},
{key: '2', value: '无'},
]
},
{
id: 7,
title: '您眼睛是否有迎风流泪现象？',
answerChooseList: [
{key: '1', value: '有'},
{key: '2', value: '无'},
]
},
{
id: 8,
title: '您是否有视力模糊？',
answerChooseList: [
{key: '1', value: '有'},
{key: '2', value: '无'},
]
},
{
id: 9,
title: '您是眼睛否有麦粒肿？',
answerChooseList: [
{key: '1', value: '有'},
{key: '2', value: '无'},
]
}
]
}
},
mounted: function () {
this.$nextTick(function () {
this.$vux.loading.show('加载中')
this.$http.get(this.tianYiWebUrl + '/wechat/spring2018/getForm').then(data => {
if (data.data.code === 200) {
this.hasAccess = data.data.data.hasAccess;
if (this.hasAccess === false)
this.textBtn = '无资格或资格已使用'
}
this.$vux.loading.hide();
});
});
},
methods: {
submit() {
this.$http.post(this.tianYiWebUrl + '/wechat/spring2018/postForm', {data: this.answer}).then(data => {
if (data.data.code === 200) {
let res = data.data.data
this.success = true;
this.redPackAmount = res.ty_amount;
this.needAmount = res.ty_need_amount;
} else {
this.$vux.alert.show(data.data.message);
}
});
},

openRedPackage() {
this.trans = true;
setTimeout(() => {
this.redPackageDisplay = 'block';
this.trans = false;
}, 2000);
}
},
watch: {
answer(o, n) {
for (let x in this.answer) {
if (this.noSubmit = this.answer[x].length === 0) break;
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/newYearActivity/from.vue